import React from "react";
import { Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, Button } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";

interface WarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  validationErrors?: { field: string; message: string }[];
  dialogTitleClassName?: string;
}

export const WarningDialog: React.FC<WarningDialogProps> = ({
  open,
  onOpenChange,
  validationErrors = [],
  dialogTitleClassName,
}) => (
  <Dialog open={open} onOpenChange={(_event, data) => onOpenChange(data.open)}>
    <DialogSurface>
      <DialogBody>
        <DialogTitle className={dialogTitleClassName}>
          <span>Warnings:</span>
          <Button icon={<Dismiss24Regular />} onClick={() => onOpenChange(false)} aria-label="Close" />
        </DialogTitle>
        <DialogContent>
          <div>
            <ul>
              {validationErrors.map((error) => (
                <li key={error.field}>{error.message}</li>
              ))}
            </ul>
          </div>
        </DialogContent>
      </DialogBody>
    </DialogSurface>
  </Dialog>
);
